import { Controller } from "@hotwired/stimulus";

export default class ShowMoreController extends Controller {
  async showMore() {
    const turboRequest = (await import("../helpers/api")).turboRequest;
    await turboRequest(this.element.dataset.url, {
      method: "GET",
      turboStream: true,
    });
  }
}
